/**
 * AyudaIA.jsx · v101.24.0 · Página completa de «Fibi», asistente virtual (Ayuda IA).
 * Chat a la izquierda; a la derecha los temas de la ayuda (clic → pregunta a Fibi).
 */
import { useCallback, useState } from "react";
import Layout from "../components/Layout";
import FibiChat from "../components/FibiChat";
import RobotMascot from "../components/RobotMascot";
import { BookOpen, ChevronDown, ChevronRight, Sparkles } from "lucide-react";

export default function AyudaIA() {
  const [topics, setTopics] = useState([]);
  const [aiOn, setAiOn] = useState(true);
  const [openIdx, setOpenIdx] = useState(0);

  const onSuggestions = useCallback((data) => {
    setTopics(data?.topics || []);
    setAiOn(data?.ai_enabled !== false);
  }, []);

  const askTopic = (title, section) => {
    window.dispatchEvent(new CustomEvent("fibi-ask", { detail: `Explícame «${section}» (${title})` }));
  };

  return (
    <Layout title="Fibi · Ayuda IA" subtitle="Tu asistente virtual">
      <div className="grid grid-cols-1 lg:grid-cols-[1fr_320px] gap-5" data-testid="ayuda-ia-page">
        <div className="rounded-2xl border border-gray-200 overflow-hidden shadow-sm flex flex-col h-[calc(100vh-200px)] min-h-[480px] bg-white">
          <div className="flex items-center gap-3 px-4 py-3 bg-[#0A3747] text-white">
            <div className="w-11 h-11 rounded-full bg-[#0E445A] flex items-center justify-center overflow-hidden">
              <RobotMascot size={44} forceDark />
            </div>
            <div className="leading-tight">
              <div className="font-semibold">Soy Fibi, tu asistente virtual</div>
              <div className="text-xs text-[#E0E621]">Pregúntame cómo funciona AlfaField: módulos, estados, app móvil, Odoo…</div>
            </div>
          </div>
          {!aiOn && (
            <div className="px-4 py-2 text-xs bg-amber-50 text-amber-800 border-b border-amber-200">
              La IA no está configurada en el servidor: Fibi responderá con las secciones de ayuda más relacionadas.
            </div>
          )}
          <div className="flex-1 min-h-0">
            <FibiChat onSuggestions={onSuggestions} />
          </div>
        </div>

        <aside className="rounded-2xl border border-gray-200 bg-white text-gray-800 shadow-sm p-4 h-fit max-h-[calc(100vh-200px)] overflow-y-auto">
          <div className="flex items-center gap-2 font-semibold text-sm mb-3">
            <BookOpen size={16} className="text-[#0A3747]" /> Temas de ayuda
          </div>
          {topics.length === 0 && <div className="text-xs text-gray-400">Cargando temas…</div>}
          <div className="space-y-1">
            {topics.map((t, i) => (
              <div key={t.title}>
                <button onClick={() => setOpenIdx(openIdx === i ? -1 : i)} className="w-full flex items-center gap-1.5 text-left text-sm py-1.5 hover:text-[#0A3747]">
                  {openIdx === i ? <ChevronDown size={14} /> : <ChevronRight size={14} />}
                  <span className="font-medium">{t.title}</span>
                </button>
                {openIdx === i && (
                  <ul className="pl-6 pb-2 space-y-1">
                    {t.sections.map((s) => (
                      <li key={s}>
                        <button onClick={() => askTopic(t.title, s)} className="text-left text-xs text-gray-600 hover:text-[#0A3747] flex items-start gap-1">
                          <Sparkles size={11} className="mt-0.5 flex-shrink-0 text-[#b5ba00]" /> {s}
                        </button>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>
        </aside>
      </div>
    </Layout>
  );
}
